/**
 * Row-Model fuer ContractsUploadModal. Liegt im eigenen File damit Row + Modal
 * keine zirkulaere Abhaengigkeit haben.
 */
import type { CreateContractRequest } from '@/shared/api';
import { guessContract } from './akteUploadDefaults';

export interface ContractRow {
  id: string;
  file: File;
  type: string;
  counterparty: string;
  monthlyAmount: string;
  currency: string;
  startDate: string;
  endDate: string;
  noticePeriodDays: string;
  autoRenewal: boolean;
  notes: string;
  status: 'idle' | 'uploading' | 'done' | 'error';
  error: string | null;
}

export function newContractRow(file: File, defaultCurrency: string): ContractRow {
  const guess = guessContract(file.name);
  return {
    id: `${file.name}-${file.size}-${file.lastModified}`,
    file,
    type: guess.type,
    counterparty: guess.counterparty,
    monthlyAmount: '',
    currency: defaultCurrency,
    startDate: new Date().toISOString().slice(0, 10),
    endDate: '',
    noticePeriodDays: '',
    autoRenewal: false,
    notes: '',
    status: 'idle',
    error: null,
  };
}

export function isContractRowValid(row: ContractRow): boolean {
  return row.type.trim() !== '' && row.counterparty.trim() !== '' && row.startDate !== '';
}

export function toCreateContractRequest(row: ContractRow): CreateContractRequest {
  const amount = row.monthlyAmount.trim() ? Number(row.monthlyAmount.replace(',', '.')) : null;
  return {
    type: row.type.trim(),
    counterparty: row.counterparty.trim(),
    monthlyAmount: amount,
    currency: row.currency || 'EUR',
    startDate: row.startDate,
    endDate: row.endDate || null,
    noticePeriodDays: row.noticePeriodDays ? Number(row.noticePeriodDays) : null,
    autoRenewal: row.autoRenewal,
    notes: row.notes.trim() || null,
  };
}
